import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    baseBackendUrl: process.env.API_ROOT || '/',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
